import { useCallback } from 'react';
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';

import { onSelectPhoto, onSelectVideo } from '../utils/upload';

import { MediaType } from '../types/enums/mediatype.enum';

function DragDropContainer({
    type,
    children,
    onMediasSelected,
    onMediasWasUploaded,
}) {
    const onDrop = useCallback((item, monitor) => {
        if (monitor) {
            const files = monitor.getItem().files;
            if (type === MediaType.VIDEO)
                onSelectVideo(
                    { files },
                    onMediasSelected,
                    onMediasWasUploaded,
                    { compress: true },
                );
            else
                onSelectPhoto(
                    { files },
                    type,
                    onMediasSelected,
                    onMediasWasUploaded,
                );
        }
    }, []);
    const [{ canDrop, isOver }, drop] = useDrop({
        accept: [NativeTypes.FILE],
        drop(item, monitor) {
            if (onDrop) {
                onDrop({ onDrop }, monitor);
            }
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    });
    const isActive = canDrop && isOver;

    return (
        <div ref={drop}>
            <div style={isActive ? { opacity: 0.3 } : {}}> {children}</div>
        </div>
    );
}

export default DragDropContainer;
